<div class="container-md" *ngIf="!!entityData">
  <div class="row my-4">
      <div class="col-2 col-lg-1" *ngIf="entityData.photoFullPath != '' && entityData.showLogo">
          <img class="logo" [src]="entityData.photoFullPath + '?w=150'" alt="Logo">
      </div>
      <div class="col-10 col-lg-11">
          <h1>{{ entityData.entityName }}</h1>
      </div>
  </div>
</div>
<div class="main-container">
  <div class="container-md">
      <app-bid-search-result
            [memorabidAuctions]="auctionsMemorabidList"
            [marketplaceAuctions]="auctionsMarketplaceList"
            [isBidBoxLarge]="true"
            (auctionStatusFilterChanged)="onAuctionStatusFilterChanged($event)">
      </app-bid-search-result>
  </div>
</div>